module.exports = __webpack_public_path__ + "static/img/10.33e18d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/10.png
// module id = nW78
// module chunks = 35